export default [
  {
    path: 'afiliados/afiliados-relatorios/comissoes-afiliados',
    name: 'comissoes-afiliados',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Comissões',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Relatórios', link: 'afiliados-relatorios' },
        { name: 'Comissões' },
      ]
    }
  },
]